<div class="ws-popup-header">
    <span>{{'Billing Data' | translate}}</span>
    <div class="actions">
        <button (click)="closeClicked()" mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div [formGroup]="invoiceData" class="ws-popup-content">
    <div class="ws-popup-body">
    <div class="invoice-type-selection">
    <mat-radio-group [(ngModel)]="invoiceType" (change)="invoiceTypeChanged()" [ngModelOptions]="{standalone: true}">
      <mat-radio-button value="person">
        {{ "Personal" | translate }}
      </mat-radio-button>
      <br>
      <mat-radio-button value="company">
        {{ "Company" | translate }}
      </mat-radio-button>
    </mat-radio-group>
    </div>

    <div class="form-grid">
        <div *ngFor="let ctrl of invoiceKeyNames; let last = last" 
             class="input-wrapper" 
             [class.half-width]="last">
            <label for="{{ctrl}}">{{ ('invoiceFields.' + ctrl) | translate }}{{ isRequired(ctrl) ? '*' : '' }}</label>
            <input *ngIf="ctrl != 'billingCountry'; else countryAutocomplete" [formControlName]="ctrl" id="{{ctrl}}"
                   matInput/>

            <ng-template #countryAutocomplete>
                <input
                        (input)="filterCountries($event)"
                        [formControlName]="ctrl"
                        [matAutocomplete]="autocompleteCountry"
                        matInput
                        type="text"
                        id="{{ctrl}}"
                />
                <mat-autocomplete #autocompleteCountry="matAutocomplete" [displayWith]="displayCountry">
                    <mat-option *ngFor="let country of filteredCountriesIsoAndNames; let i = index" [value]="country.iso">
                        <ws-flag 
                            [countryCode]="country.iso"
                            size="small"
                            [showBorder]="true"
                        ></ws-flag>
                        {{ displayCountry('', country) }}
                    </mat-option>
                </mat-autocomplete>
            </ng-template>
        </div>
    </div>

</div>
<div class="ws-popup-footer">
    <span></span>
    <div class="actions-footer">
        <ws-button (click)="closeClicked()" [callToActionType]="'tertiary'">
            {{ 'Back' | translate }}
        </ws-button>
        <ws-button (click)="saveClicked()" [callToActionType]="'primary'">
            {{ 'Save' | translate }}
        </ws-button>
  </div>
</div>
</div>